import { Accordion, Card } from "#/atoms";
import { FC, memo, useCallback, useState } from "react";

import { DESKTOP_SPACING } from "@/theme";
import { FloorPlanSurchargeModal } from "#/organisms";
import { HeadingIcon } from "#/molecules";
import OrderServiceHeader from "./OrderServiceHeader";
import PhotoUploader from "./PhotoUploader";
import { PlanProps } from "./OrderService.interface";
import { useModal } from "@/hooks";

const FloorPlan: FC<PlanProps> = ({
  amount,
  draftFiles,
  isAdmin,
  isOffered = false,
  isWorker,
  name,
  notificationMessage,
  notifications,
  onAskToChangeWorker,
  onDeleteFiles,
  onDownloadFiles,
  onGetFloorArea,
  onNotifyCustomer,
  onRecordFloorArea,
  onUploadFiles,
  selectedWorkerName,
  serviceId,
  uploadedFiles,
  orderState,
  outtakesMode,
  type
}) => {
  const { showModal: showFloorPlanModal, onCloseModal: onFloorPlanClose, onOpenModal: onFloorPlanOpen } = useModal();

  const [floorArea, setfloorArea] = useState<number>(0);

  const accordionState = 'open';

  // const handleCombinePhoto = useCallback(() => {
  // }, [draftFiles]);

  const handleDeleteFiles = async (serviceIdInput: string, files: string[], isDraft : boolean) => {
   await onDeleteFiles?.(serviceIdInput, files, isOffered, isDraft);
  }

  const handleDownloadFiles = async (serviceIdInput: string, files: string[], isDraft : boolean) => {
    await onDownloadFiles(serviceIdInput, files, isDraft);
  }

  const handleUploadFiles = async (serviceIdInput: string, files: File[], isDraft : boolean) => {
    await onUploadFiles?.(serviceIdInput, files, isDraft);
  }

  const handleOpenFloorPlanSurcharge = useCallback(() => {
    onGetFloorArea?.(serviceId).then(
      (area: number) => {
        setfloorArea(area);
        onFloorPlanOpen();
      }
    )
  }, [serviceId]);

  const handleRecordFloorPlanSurcharge = useCallback((recordedFloorArea) => {
    onRecordFloorArea?.(serviceId, recordedFloorArea).then(() => {
    onFloorPlanClose();
    });
  }, [serviceId]);

  const handleChangeWorker = useCallback(() => {
    onAskToChangeWorker?.(serviceId);
  }, [serviceId])

  return (
    <Card>
        <Accordion
          header={<HeadingIcon icon="services" mb={`${DESKTOP_SPACING.XXL}px`} title={`${name} ${amount ? " X" + amount : ""}`} />}
          showArrow
          state={accordionState}
        >
          { isAdmin &&  <OrderServiceHeader
                          name={name}
                          notificationMessage={notificationMessage}
                          notifications={notifications}
                          onAskToChangeWorker={handleChangeWorker}
                          onNotifyCustomer={onNotifyCustomer}
                          selectedWorkerName={selectedWorkerName}
                          serviceId={serviceId}
                          type={type} /> }

          {!isWorker && <PhotoUploader
            files={uploadedFiles}
            isAdmin={isAdmin}
            isDraft = {false}
            isPlan = {true}
            notifications={notifications}
            onDeleteFiles={handleDeleteFiles}
            onDownloadFiles={handleDownloadFiles}
            onOpenFloorPlanSurcharge={handleOpenFloorPlanSurcharge}
            onUploadFiles={handleUploadFiles}
            orderState={orderState}
            outtakesMode={outtakesMode}
            serviceId={serviceId} /> }

          { (isAdmin || isWorker) && <PhotoUploader
            files={draftFiles || []}
            isDraft = {true}
            isPlan = {true}
            isWorker={isWorker}
            title="2D Floor Plan Sketches"
            notifications={notifications}
            onDeleteFiles={handleDeleteFiles}
            onDownloadFiles={handleDownloadFiles}
            onUploadFiles={handleUploadFiles}
            serviceId={serviceId} /> }
          
        {showFloorPlanModal && (
          <FloorPlanSurchargeModal
            floorArea={floorArea}
            onClose={onFloorPlanClose}
            onConfirm={handleRecordFloorPlanSurcharge}
          />
        )}
      </Accordion>
     </Card>
  );
};

export default memo(FloorPlan);